import { Link } from "react-router-dom";
import styles from "./landing.module.css";
import { motion } from "framer-motion";
import { FaPager } from "react-icons/fa";
import { AiFillBook } from "react-icons/ai";
import { TbReportAnalytics } from "react-icons/tb";
import main_bg from "./imgs/main.png";
// swiper js
import React, { useRef, useState } from "react";
// Import Swiper React components
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
export default function Arabic_Landing() {
  const [show, setShow] = useState(false);
  const images = [
    require("./opinion imgs/feedback1.a1767c061dd4114e43fb.png"),
    require("./opinion imgs/feedback2.144e7f71eed31fd34cc3 (1).png"),
    require("./opinion imgs/feedback3.e377fb8ff671b824e9b3.png"),
    require("./opinion imgs/feedback4.2d7d2a27060a23076903.png"),
    require("./opinion imgs/feedback5.658ae11ef87542372b82.png"),
    require("./opinion imgs/feedback6.a43d3b722e6b60252e8c.png"),
    require("./opinion imgs/feedback7.613c5de72341a0f01143.png"),
    require("./opinion imgs/feedback8.0d4e09d47ba1abf65e82.png"),
    require("./opinion imgs/feedback9.39bbe72168e547cc834e.png"),
  ];
  return (
    <>
      <header className={`${styles.header}`}>
        <nav className={`${styles.nav}`}>
          <ul className={`${styles.ul}`}>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <a href="#">الرئيسية</a>
            </motion.li>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <a href="#services">الخدمات</a>
            </motion.li>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.6 }}
            >
              <a href="#pricing">الاسعار</a>
            </motion.li>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.8 }}
            >
              <a href="#contact"> تواصل معنا</a>
            </motion.li>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 1 }}
            >
              <a href="#opinion">رأي العملاء </a>
            </motion.li>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 1.2 }}
            >
              <Link to={"/landing"}>English</Link>
            </motion.li>
          </ul>
        </nav>
      </header>

      <header
        className={`${styles.mobile_header}`}
        onClick={() => {
          setShow(!show);
        }}
      >
        <nav className={`${styles.nav} ${show ? styles.show : ""}`}>
          <ul className={`${styles.ul}`}>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <a href="#">الرئيسية</a>
            </motion.li>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <a href="#services">الخدمات</a>
            </motion.li>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.6 }}
            >
              <a href="#pricing">الاسعار</a>
            </motion.li>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.8 }}
            >
              <a href="#contact"> تواصل معنا</a>
            </motion.li>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 1 }}
            >
              <a href="#opinion">رأي العملاء </a>
            </motion.li>
            <motion.li
              className={`${styles.li}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 1.2 }}
            >
              <Link to={"/landing"}>English</Link>
            </motion.li>
          </ul>
        </nav>
        <div className={`${styles.menu}`}>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </header>

      <main className={`${styles.main}`}>
        <img src={main_bg} alt="" className={`${styles.bg}`} />
        <div className={`${styles.container}`}>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1 }}
          >
            مرحبا في شركة اعزمك للحفلات والمناسبات
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1.2 }}
          >
            شركة اعزمك لجميع انواع المناسبات و الدعوات الالكترونية
          </motion.p>
          <motion.a
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 1.5 }}
          >
            تواصل معنا
          </motion.a>
        </div>
      </main>

      <section className={`${styles.services}`} id="services">
        <motion.h2
          className={`${styles.section_title}`}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          خدماتنا
        </motion.h2>

        <div className={`${styles.container}`}>
          <motion.div
            className={`${styles.box}`}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <AiFillBook
              className={`${styles.icon}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.8 }}
            />
            <motion.h2
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 1.4 }}
            >
              تصميم الدعوات
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 2 }}
            >
              تصميم كروت الدعوات لاي نوع من المناسبات
            </motion.p>
          </motion.div>
          <motion.div
            className={`${styles.box}`}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <FaPager
              className={`${styles.icon}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 1 }}
            />
            <motion.h2
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 1.6 }}
            >
              الدعوات الالكترونية
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 2.2 }}
            >
              عمل دعوات الكترونية لسهولة الوصول للمدعوين
            </motion.p>
          </motion.div>
          <motion.div
            className={`${styles.box}`}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <TbReportAnalytics
              className={`${styles.icon}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 1.2 }}
            />
            <motion.h2
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 1.8 }}
            >
              {" "}
              تقارير الحفلات
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 2.4 }}
            >
              {" "}
              يمكننا تقديم تقارير كاملة للحفلة شاملة كافة البيانات المهمة
            </motion.p>
          </motion.div>
        </div>
      </section>

      <section className={`${styles.opinion}`} id="opinion">
        <motion.h2
          className={`${styles.section_title}`}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          رأي العملاء
        </motion.h2>

        <div className={`${styles.container}`}>
          <Swiper
            slidesPerView={5}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Pagination]}
            className="mySwiper"
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              480: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              640: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
              1016: {
                slidesPerView: 5,
                spaceBetween: 30,
              },
            }}
          >
            {images.map((src, index) => {
              return (
                <>
                  <SwiperSlide key={index}>
                    <img src={src} alt="img not found" />
                  </SwiperSlide>
                </>
              );
            })}
          </Swiper>
        </div>
      </section>

      <footer className={`${styles.footer}`}>
        <span>هذا المشروع مملوك لشركة مركز سان لوران لتأجير معدات الأفراح</span>
        <span> رقم الترخيص: 206119</span>
        <span> الموقع: الكويت</span>
        <span>© 2024 إعزمك، جميع الحقوق محفوظة </span>
      </footer>
    </>
  );
}
